import React from 'react'
import { FormattedMessage } from 'react-intl'
import { accentuate } from '../'
import { Section, ExternalLinkBlock, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'

const AzureHowToUse = ({ data }) => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_how_to_use"
                defaultMessage="How to use" />
        </Heading>
        <Paragraph>
            <FormattedMessage
                id="integration_azure_how_to_use_preamble"
                defaultMessage="To get started, you will need a <accent>Tenant ID</accent>, <accent>Client ID</accent> and <accent>Client secret</accent> provided by Azure Active Directory. Read more about how to get them in our knowledge base."
                values={{ accent: accentuate }} />
        </Paragraph>
        <ExternalLinkBlock href={data.knowledgebaseUrl}>
            <FormattedMessage
                id="integration_azure_link_knowledgebase"
                defaultMessage="Using the Azure Active Directory integration" />
        </ExternalLinkBlock>
    </Section>
)

export default AzureHowToUse